import { Observable } from "rxjs/Observable";
import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Constants } from "./../../../helper/constants";
import { AngularFireObject } from "angularfire2/database";
import { Community } from "../../services/community/community";

@Injectable()
export class CommunityService {
  communities = undefined;
  private profilePath;
  profileItem: AngularFireObject<any>;

  constructor(private db: AngularFireDatabase) {
    this.profilePath = Constants.PROFILE_REF;
  }

  getCommunities(): Observable<Array<Community | any>> {
    return this.db.list("/communities").valueChanges();
  }

  getCommunityById(communityId): Observable<Community | any> {
    return this.db.object(`/communities/${communityId}`).valueChanges();
  }

  getCommunityStatus(billTypeId, communityId): Observable<Array<{}>> {
    return this.db
      .list(`/community_billtype/${communityId}/${billTypeId}/status`)
      .valueChanges();
  }

  create(community): any {
    const communityRef = this.db.list("/communities");

    return communityRef
      .push(community)
      .then(data => communityRef.update(data.key, { id: data.key }));
  }

  update(community): any {
    return this.db.list("/communities").update(community.id, community);
  }

  delete(communityId): void {
    this.db
      .object(`/communities/${communityId}`)
      .remove()
      .then(_ => {
        this.clearOrphanCommunitiesFromProfile(communityId);
        this.db.object(`/users/ + ${communityId}`).remove();

        return true;
      })
      .catch(err => {
        console.log(err, "You dont have access!");

        return false;
      });
  }

  clearOrphanCommunitiesFromProfile(communityId: string): void {
    this.db
      .object(this.profilePath)
      .snapshotChanges()
      .subscribe(profiles => {
        const profileKeys = Object.keys(profiles.payload.val());

        for (const key of profileKeys) {
          const profile = profiles.payload.val()[key];
          this.profileItem = this.db.object(this.profilePath + "/" + key);

          if (profile["communities"] !== undefined) {
            if (profile["communities"][communityId] !== undefined) {
              if (communityId === profile["communities"][communityId]["id"]) {
                delete profile["communities"][communityId];
                this.profileItem.update(profile);
              }
            }
          }
        }
      });
  }

  deactivate(communityId): any {
    const communityState = {
      isActive: false
    };
    this.db.list(`/communities`).update(communityId, communityState);
    this.db.list(`/resource_status_change_watch`).update(communityId, communityState);

  }

  activate(communityId): any {
    const communityState = {
      isActive: true
    };
    this.db.list(`/communities`).update(communityId, communityState);
    this.db.list(`/resource_status_change_watch`).update(communityId, communityState);

  }

  checkIfPropertiesExist(communityId: string): Observable<Array<any>> {

    return this.db.list(`/properties/${communityId}`).valueChanges();
  }

  getEmailsOfAccessTerminalPersonnels(communityId: string): Observable<any> {
    return this.db
    .object(`/community_resources/${communityId}/Access Terminal Personnel`)
    .valueChanges();
  }

  getEmailsOfCommunityManagers(communityId: string): Observable<any> {
    return this.db
    .object(`/community_resources/${communityId}/Community Manager`)
    .valueChanges();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/community/community.service.ts